// extracted by mini-css-extract-plugin
export default {"root":"GAorDl","title":"gx_5eV","list":"Ko5D8x","icon":"_C4p2q"};